import { IRawCinematics } from '@/types'
import { debug } from '@/utils/debug'

import settings from '@/settings/public'

/** Cookie store shape (e.g. from next/headers cookies()) — only needed for server-side fetches that must forward cookies */
interface ICookieStore {
  getAll(): { name: string; value: string }[]
}

interface IFetchCinematicsOptions {
  tag: string
  /** Pass cookies when calling from server (e.g. layout) to forward session; omit for client fetches (browser sends cookies automatically) */
  cookies?: ICookieStore
  /** Server-only: client headers to forward on the loopback fetch (buildSsrForwardHeaders, PRO-946). */
  forwardHeaders?: Record<string, string>
}

export const fetchCinematics = async (args: IFetchCinematicsOptions): Promise<IRawCinematics['data']> => {
  const { tag, cookies: cookieStore, forwardHeaders } = args

  try {
    // Build cookie header string if  cookies are provided (server-side)
    const cookieHeader = cookieStore
      ? cookieStore.getAll().map(cookie => `${cookie.name}=${cookie.value}`).join('; ')
      : undefined

    const headers: Record<string, string> = { ...forwardHeaders }
    if (cookieHeader) {
      headers['Cookie'] = cookieHeader
    }

    const cinematicsResponse = await fetch(`${settings.api.host}/api/generic/cinematics?tag=${tag}`, {
      headers,
    })
    const json: IRawCinematics = await cinematicsResponse.json()

    return json.data
  } catch (error) {
    debug.error('Error fetching cinematics:', error)
    throw error
  }
}